import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Link } from "@inertiajs/react";

const ReferralBanner = () => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: { xs: "150px", mds: "200px" },
      }}
    >
      <Link href="referral-program">
        <Box sx={{ display: { xxs: "flex", xsm: "none" }, width: "100%", height: "100%" }}>
          <img
            src="/images/banners/referral-mobile-banner-no-text.png"
            alt="Referral Banner Mobile"
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              objectFit: "fill",
              transition: "opacity 0.3s ease-in-out",
            }}
          />
        </Box>

        <Box sx={{ display: { xxs: "flex", mds: "none" }, width: "100%", height: "100%" }}>
          <img
            src="/images/banners/referral-tablet-banner-no-text.png"
            alt="Referral Banner Tablet"
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              objectFit: "fill",
              transition: "opacity 0.3s ease-in-out",
            }}
          />
        </Box>

        <Box sx={{ display: { xxs: "none", mds: "flex" }, width: "100%", height: "100%" }}>
          <img
            src="/images/banners/referral-desktop-banner-no-text.png"
            alt="Referral Banner Desktop"
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              objectFit: "cover",
              transition: "opacity 0.3s ease-in-out",
            }}
          />
        </Box>

        <Box
          sx={{
            position: "absolute",
            top: { xxs: 0, mds: 30, sm: 0 },
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: { xxs: "center", mds: "normal", sm: "center" },
            alignItems: "center",
            color: "#00719C",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: 700,
              fontSize: { xs: "16.49px", xsm: "27.97px", mds: "32.77px" },
              lineHeight: "90%",
              letterSpacing: "-0.5px", // percentage is invalid in letter-spacing
              textAlign: "center",
            }}
          >
            Refer Creators and Get Paid!
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: 400,
              fontSize: { xs: "16.49px", xsm: "27.97px", mds: "32.77px" },
              lineHeight: "90%",
              letterSpacing: "-0.5px",
              textAlign: "center",
            }}
          >
            Up to&nbsp;
            <Box
              component="span"
              sx={{
                fontWeight: 700,
              }}
            >
              $200
            </Box>
            &nbsp;Per Referral!
          </Typography>

          <Button color="#00719C" variant="outlined" sx={{ mt: 1 }}>
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: 500,
                fontStyle: "italic",
                fontSize: { xs: "16.49px", mds: "12.94px" },
                lineHeight: "100%",
                letterSpacing: "-0.5px",
                textAlign: "center",
              }}
            >
              Click to learn more
            </Typography>
          </Button>
        </Box>
      </Link>
    </Box>
  );
};

export default React.memo(ReferralBanner);
